module.exports = __webpack_public_path__ + "static/img/album3_202501_01.32d2d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album3_202501_01.jpg
// module id = sbmv
// module chunks = 99